import { render, staticRenderFns } from "./approval-handle.vue?vue&type=template&id=53c5fec8&"
import script from "./approval-handle.vue?vue&type=script&lang=js&"
export * from "./approval-handle.vue?vue&type=script&lang=js&"
import style0 from "./approval-handle.vue?vue&type=style&index=0&id=53c5fec8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports